import { connectRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import reduceReducers from "reduce-reducers";
import { combineReducers } from "redux";

import { sessionActions } from "../actions";
import { initialState } from "../initialState";
import { createReducer } from "./utilities";

import { activityReducer } from "./activity.reducer";
import { bannerReducer } from "./banner.reducer";
import { faqReducer } from "./faq.reducer";
import { fileReducer } from "./file.reducer";
import { imageReducer } from "./image.reducer";
import { magazineReducer } from "./magazine.reducer";
import { meetingReducer } from "./meeting.reducer";
import { nationReducer } from "./nation.reducer";
import { columnReducer } from "./column.reducer";
import { newReducer } from "./new.reducer";
import { numberReducer } from "./number.reducer";
import { sessionReducer } from "./session.reducer";
import { tagReducer } from "./tag.reducer";
import { videoReducer } from "./video.reducer";

import { eurofileReducer } from "./eurofile.reducer";

const browserHistory = createBrowserHistory();

const rootReducer = combineReducers({
  session: sessionReducer,
  image: imageReducer,
  file: fileReducer,
  nation: nationReducer,
  column: columnReducer,
  number: numberReducer,
  new: newReducer,
  banner: bannerReducer,
  router: connectRouter(browserHistory),
  activity: activityReducer,
  video: videoReducer,
  tag: tagReducer,
  magazine: magazineReducer,
  faq: faqReducer,
  meeting: meetingReducer,
  eurofile: eurofileReducer
});

const globalReducer = createReducer(initialState, {
  [sessionActions.LOGOUT]: () => initialState
});

export default reduceReducers(initialState, rootReducer, globalReducer);
